// extracted by mini-css-extract-plugin
export default {"selectWrapper":"_WaKiFrQ","select":"OT1WZcsx"};